import React from "react";
import {Link, Outlet, useParams} from "react-router-dom";
import {Menu} from 'antd';
import {
    AppstoreFilled,
    ArrowLeftOutlined,
    DashboardFilled,
    NotificationFilled,
    ProfileOutlined,
    RocketOutlined,
    SettingFilled,
    ShopOutlined,
    UsergroupAddOutlined
} from '@ant-design/icons';

export const DeveloperPage = (props) => {
    const params = useParams();
    let activeIndex = [''];
    const isAppPage = window.location.pathname.indexOf('/app/') + 1 > 0;

    if (isAppPage) {
        let params = window.location.pathname.split('/');
        activeIndex = [params[params.length - 1]];

        if (['store', 'release', 'notifications', 'stats'].indexOf(params[params.length - 1]) + 1 === 0) {
            activeIndex = ['index'];
        }

        if (window.location.href.indexOf(`/release/`) + 1) {
            activeIndex = ['release'];
        }

    } else {
        let params = window.location.pathname.split('/');
        activeIndex = [params[params.length - 1]];
    }


    return (
        <div className={`console dev_layout`}>
            <div className={`dev__sidebar`}>
                <div className="menu__wrapper">
                    {isAppPage === false && (
                        <Menu selectedKeys={activeIndex}>
                            <Menu.Item key={'index'} icon={<AppstoreFilled/>}><Link
                                to={`/console/${params.developer_id}`}>Приложения</Link></Menu.Item>
                            <Menu.Item key={'account'} icon={<ProfileOutlined/>}><Link
                                to={`/console/${params.developer_id}/account`}>Настройки аккаунта</Link></Menu.Item>
                            <Menu.Item key={'page'} icon={<SettingFilled/>}><Link
                                to={`/console/${params.developer_id}/page`}>Настройки страницы</Link></Menu.Item>
                            <Menu.Item
                                disabled={true}
                                key={'notifications'}
                                icon={<NotificationFilled/>}>
                                <Link to={`/console/${params.developer_id}/notifications`}>Уведомления</Link>
                            </Menu.Item>
                            <Menu.Item disabled={true} key={'users'} icon={<UsergroupAddOutlined/>}><Link
                                to={`/console/${params.developer_id}/users`}>Пользователи</Link></Menu.Item>
                            <Menu.Item disabled={true} key={'reports'} icon={<DashboardFilled/>}><Link
                                to={`/console/${params.developer_id}/reports`}>Отчеты</Link></Menu.Item>
                        </Menu>
                    )}
                    {isAppPage && (
                        <Menu selectedKeys={activeIndex}>
                            <Menu.Item key={'apps'}>
                                <Link to={`/console/${params.developer_id}`}>
                                    <ArrowLeftOutlined/>
                                    <span>Все приложения</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key={'index'} icon={<AppstoreFilled/>}>
                                <Link to={`/console/${params.developer_id}/app/${params.app_id}`}>Панель
                                    управления</Link>
                            </Menu.Item>
                            <Menu.Item key={'store'} icon={<ShopOutlined/>}>
                                <Link to={`/console/${params.developer_id}/app/${params.app_id}/store`}>Редактировать
                                    описание</Link>
                            </Menu.Item>
                            <Menu.Item key={'release'} icon={<RocketOutlined/>}>
                                <Link to={`/console/${params.developer_id}/app/${params.app_id}/release`}>Управление
                                    выпусками</Link>
                            </Menu.Item>
                            <Menu.Item disabled={true} key={'notifications'} icon={<NotificationFilled/>}>
                                <Link
                                    to={`/console/${params.developer_id}/app/${params.app_id}/notifications`}>Уведомления</Link>
                            </Menu.Item>
                            <Menu.Item disabled={true} key={'stats'} icon={<DashboardFilled/>}>
                                <Link
                                    to={`/console/${params.developer_id}/app/${params.app_id}/stats`}>Статистика</Link>
                            </Menu.Item>
                        </Menu>
                    )}

                </div>
            </div>
            <div className={`dev__container`}>
                <Outlet/>
            </div>
        </div>
    );
}

export default DeveloperPage;